jQuery( function( $ ) {
	$( document ).ready( function() {

		cookiesJS = ( function() {

			var
				_bar = false,

				init = function() {
					_displayBar();
				},

				_displayBar = function() {
					$.ajax({
						url: wps.ajax,
						type: 'POST',
						data: {
							action: 'show_cookie_bar_js'
						}
					}).done( function( response ) {
						if ( response.data.show ) {
							_bar = $( response.data.data );
							$( '#cookie-bar-js' ).append( _bar );

							_bar.on( 'closed.bs.alert', function() {
								_dismissCookieBar();
							});
						}
					});
				},

				_dismissCookieBar = function(  ) {
					$.ajax({
						url: wps.ajax,
						type: 'POST',
						data: {
							action: 'dismiss_cookie_bar'
						}
					}).fail( function( response ) {
						console.log( response );
					});
				}
			;

			return {
				init: init
			};

		}() );

	});
});
